module.exports = __webpack_public_path__ + "img/banner0.071ea604.png";